import version from "../../version.json";

/**
 * Records the current build version so we can tell when a new one has shipped.
 *
 * We deliberately do NOT log the user out or pop a "please refresh" banner on a version
 * change: the browser already loads the new hashed bundle on the next navigation, so the
 * banner changed nothing visible and just confused people — and clearing the token logged
 * everyone out on every deploy. Now it silently updates the stored version.
 */
export const CheckVersion = () => {
    const localVersion = localStorage.getItem('version');
    if (localVersion !== version.version) {
        localStorage.setItem('version', version.version);
    }
    return null;
};
